export const LIGHT_GRADIENT_PROPS = {
  startColor: '#5ABAEE',
  endColor: '#EEC875',
  startOpacity: 0.12,
  endOpacity: 0.12,
}

export const DARK_CARD_BACKGROUND_COLOR = '#272425'

export const DARK_GRADIENT_PROPS = {
  startColor: '#0F3642',
  middleColor: '#263B35',
  endColor: '#594321',
  startOpacity: 0.3,
  middleOpacity: 0.3,
  endOpacity: 0.3,
  middleOffset: 0.52,
}
